import * as React from "react";
import { Popup } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const faQuestionC = faQuestionCircle as IconProp;
const faTimesP = faTimes as IconProp;

interface PfTooltipProps {
  tooltipText: string;
}

export const PfTooltip = ({ tooltipText }: PfTooltipProps) => {
  const [isOpen, setIsOpen] = React.useState(false);

  let timer = setTimeout(() => {}, 0);

  const updateTimer = () => {
    timer = setTimeout(() => {
      setIsOpen(false);
    }, 500);
  };

  const trigger = (
    <span
      data-testid="pfTooltip"
      onMouseOver={() => {
        clearTimeout(timer);
        setIsOpen(true);
      }}
      onFocus={() => {
        clearTimeout(timer);
        setIsOpen(true);
      }}
      onMouseOut={() => {
        updateTimer();
      }}
      onBlur={() => {
        updateTimer();
      }}
    >
      <FontAwesomeIcon style={{ color: "#0069a6" }} icon={faQuestionC} />
    </span>
  );
  return (
    <Popup
      data-testid="popUpToolTip"
      onMouseOver={() => {
        clearTimeout(timer);
        setIsOpen(true);
      }}
      onFocus={() => {
        clearTimeout(timer);
        setIsOpen(true);
      }}
      onMouseOut={() => {
        updateTimer();
      }}
      onBlur={() => {
        updateTimer();
      }}
      trigger={trigger}
      basic
      open={isOpen}
      flowing
      style={{
        color: "#666",
        boxShadow: "2px 2px 2px #999",
        borderRadius: "3px",
        border: "1px solid #b2bbbb",
        maxWidth: "300px",
        backgroundColor: "white",
        margin: "5px"
      }}
    >
      <Popup.Content>
        <div style={{ position: "absolute", right: "8px", top: "4px" }}>
          <span
            onClick={() => {
              setIsOpen(false);
              clearTimeout(timer);
            }}
            role="button"
            tabIndex={0}
            onKeyDown={() => {
              setIsOpen(false);
              clearTimeout(timer);
            }}
          >
            <FontAwesomeIcon style={{ color: "black" }} icon={faTimesP} />
          </span>
        </div>
        <div style={{ margin: "15px" }}>{tooltipText}</div>
      </Popup.Content>
    </Popup>
  );
};
